import React from 'react';
import { useExternalLinkBlocking } from '../../hooks/useExternalLinkBlocking';

interface ExternalLinkBlockingProviderProps {
  children: React.ReactNode;
}

/**
 * Provider component that handles external link blocking when `EXTERNAL_LINK_BLOCKING_ENABLED` is set
 * (see `isExternalLinkWarningEnvironment` in `externalLinkUtils`).
 * This component should be placed high in the component tree to intercept all
 * navigation attempts that might lead to external URLs.
 *
 * Features:
 * - Blocks navigation to external URLs and shows warning modal via PopupContext
 * - Allows internal navigation
 * - Opens external links in new window after user confirmation
 */
const ExternalLinkBlockingProvider: React.FC<ExternalLinkBlockingProviderProps> = ({ children }) => {
  useExternalLinkBlocking();
  return <>{children}</>;
};

export default ExternalLinkBlockingProvider;
